import Vue from 'vue';
import _ from 'lodash';

import apiFactory from '@/api/default';
const API = apiFactory('images');
const nokAPI = apiFactory('detections/nok');

import productsHelper from '@/helpers/products.helper';

const state = {
  imageSearchResults: [],
  currentImage: {},
};

const getters = {
  imageSearchResults: (state) => state.imageSearchResults,
  currentImage: (state) => state.currentImage,
};

const mutations = {
  setImageSearchResults: (state, imageSearchResults) => {
    state.imageSearchResults = imageSearchResults;
  },
  addToImageSearchResults: (state, imageSearchResults) => {
    if (Array.isArray(state.imageSearchResults)) {
      state.imageSearchResults.push(...imageSearchResults);
    } else {
      console.error('imageSearchResults property is not an array. This should never happen!');
    }
  },
  updateImageSearchResults: (state, task) => {
    const index = state.imageSearchResults.findIndex((el)=>el._id === task._id);
    if (index >= 0) Vue.set(state.imageSearchResults, index, task);
  },
  removeFromImageSearchResults: (state, id)=>{
    state.imageSearchResults.data = state.imageSearchResults.filter((obj)=>{
      return obj._id !== id;
    });
    state.imageSearchResults.total--;
  },
  updateCurrentImageProperties: (state, properties) => {
    for (const key in properties) {
      if (Object.prototype.hasOwnProperty.call(properties, key)) {
        Vue.set(state.currentImage, key, properties[key]);
      }
    }
  },
  setCurrentImage: (state, currentImage) => {
    state.currentImage = currentImage;
  },
};

const actions = {
  async searchImages({commit}, data) {
    let response;
    if (data.useNOK) {
      response = await nokAPI.search(data.query);
    } else {
      response = await API.search(data.query);
    }
    if (data.setResultsInStore) {
      commit('setImageSearchResults', response.data);
    } else if (data.addToStoreResults) {
      commit('addToImageSearchResults', response.data);
    }
    return response.data;
  },
  async loadImage({commit}, data) {
    const response = await API.load(data.id, data.query);

    commit('setCurrentImage', response.data);
    return response.data;
  },
  async createImage({commit}, data) {
    const response = await API.create(data);
    return response.data;
  },
  async updateImage({commit}, payload) {
    const response = await API.update(payload.id, payload.data);
    commit('updateImageSearchResults', response.data);
    return response.data;
  },
  /**
   * Update currentImage with populated props, de-populate them and updated the image in the DB
   *
   * @param {*} store - The Vuex store
   * @param {*} payload - object, supplied when calling this action
   * @property {string} [payload.id] - the _id of the image to be updated
   * @property {*} payload.props - properties to de-populate and save
   * @return {*} - server response
   */
  async updateImageProperty(store, payload) {
    const {id, props} = payload;
    const {getters, commit} = store;
    const populatedProperties = _.cloneDeep(props);
    // de-populate props
    for (const key of Object.keys(props)) {
      // We are using the function from the product helper. It does not care if the supplied prop is from product
      // or from image
      productsHelper.dePopulateProperty(props, key);
    }
    // Supplied id takes precedence
    let imageId = undefined;
    if (id) {
      imageId = id;
    } else if (getters.currentImage._id) {
      imageId = getters.currentImage._id;
    } else {
      // No need to translate this since it is for developers eyes only!
      throw new Error('No id supplied and currentImage is not loaded');
    }
    const response = await API.update(imageId, props);
    // If the update is successful update currentImage with populated props
    commit('updateCurrentImageProperties', populatedProperties);
    return response.data;
  },
  async deleteImage({commit}, id) {
    const response = await API.remove(id);
    commit('removeFromImageSearchResults', id);
    return response;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
